import React, { useState, useRef, useEffect } from 'react';
import './Header.css';

function Header() {
  const [showCertifications, setShowCertifications] = useState(false);
  const certifRef = useRef(null); // Référence pour détecter les clics à l'extérieur

  const certifications = [
    { name: "AWS Certified Cloud Support Associate", link: "/certifs/AWS_cloud_support.pdf" },
    { name: "Certified IBM Introduction to DevOps", link: "/certifs/IBM_DevOps.pdf" },
    { name: "Meta BackEnd developer", link: "/certifs/Meta_backend.pdf" },
    { name: "Meta FrontEnd developer", link: "/certifs/Meta_frontend.pdf" },
  ];

  // Fonction pour fermer la liste si on clique en dehors
  useEffect(() => {
    function handleClickOutside(event) {
      if (certifRef.current && !certifRef.current.contains(event.target)) {
        setShowCertifications(false);
      }
    }

    if (showCertifications) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showCertifications]);

  return (
    <>
      <nav className="navbar navbar-expand-lg bg-body-tertiary">
        <div className="container-fluid">
          <a className="navbar-brand" href="/#home">Mon Portfolio</a>
          <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarText" aria-controls="navbarText" aria-expanded="false" aria-label="Toggle navigation">
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarText">
            <ul className="navbar-nav me-auto mb-2 mb-lg-0">
              <li className="nav-item"><a className="nav-link" href="#home">Home</a></li>
              <li className="nav-item"><a className="nav-link" href="#about">À propos</a></li>
              <li className="nav-item"><a className="nav-link" href="#skills">Compétences</a></li>
              <li className="nav-item"><a className="nav-link" href="#portfolio">Portfolio</a></li>
              <li className="nav-item"><a className="nav-link" href="#experience">Expériences</a></li>
              <li className="nav-item"><a className="nav-link" href="#contact">Contact</a></li>
            </ul>
            <span className="navbar-text">
              <button className="certif-button" onClick={() => setShowCertifications(!showCertifications)}>
                Explorez mes certifs !
              </button>
            </span>
          </div>
        </div>
      </nav>

      {showCertifications && (
        <div className="certifications-list" ref={certifRef}>
          <h3>Mes Certifications :</h3>
          <ul>
            {certifications.map((certif, index) => (
              <li key={index}>
                <a href={certif.link} target="_blank" rel="noopener noreferrer">
                  {certif.name}
                </a>
              </li>
            ))}
          </ul>
        </div>
      )}
    </>
  );
}

export default Header;
